<template>
  <div class="h-flex container-wrapper">
    <Sidebar />
    <div class="v-flex">
      <LegacyNavBar v-if="$store.getters.isLegacyUser" />
      <Navbar v-else />
      <slot />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Navigation/Sidebar/Sidebar'
import Navbar from '@/components/Navigation/Navbar/Navbar'
import LegacyNavBar from '@/components/Navigation/LegacyNavBar/LegacyNavBar'

export default {
  components: {
    Sidebar,
    Navbar,
    LegacyNavBar
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.container-wrapper {
  height: 100vh;
}
</style>
